module.exports = __webpack_public_path__ + "static/media/classroom.5cd4b567.JPG";